import DataTable from './../DataTable'
import EventBus from '@/EventBus'
export default {
  mixins: [DataTable],
  methods: {
    privateLinkMode(props) {
      let vm = this
      if(!vm.config.linkMode) { return null }
      let result = vm.R.clone(vm.config.linkMode.route)
      for(let key in result.query) {
        result.query[key] = eval(result.query[key])
        result.params[key] = eval(result.params[key])
      }
      if(vm.config.linkMode.evalAll) {
        result.path = eval(result.path)
        result.name = eval(result.name)
      }
      return result
    },
    routeDetail(props) {
      if(this.config.linkMode) {
        let to = this.privateLinkMode(props)
        if(to && props.row.hasOwnProperty(this.config.linkMode.clickAbleProps)) {
          this.$router.push(to)
          EventBus.$emit('reloadPage', null)
        }
      }
    }
  },
}
